import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        // Vue 3 Composition API setup
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
